export default __webpack_public_path__ + "static/media/LOGO_FACEBOOK.666e5a5b.svg";